customElements.get('video-gallery-slider') || customElements.define('video-gallery-slider', class extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-track]');
    this.originals = Array.from(this.track.children);
    this.prevBtn = this.querySelector('[data-prev]');
    this.nextBtn = this.querySelector('[data-next]');

    const count = this.originals.length;
    if (!count) return;

    const cloneCount = Math.min(3, count);
    const leadingClones = this.originals.slice(count - cloneCount).map((item) => item.cloneNode(true));
    const trailingClones = this.originals.slice(0, cloneCount).map((item) => item.cloneNode(true));

    leadingClones.forEach((clone) => this.track.insertBefore(clone, this.track.firstChild));
    trailingClones.forEach((clone) => this.track.appendChild(clone));

    this.items = Array.from(this.track.children);
    this.count = count;
    this.realStart = cloneCount;
    this.realEnd = cloneCount + count - 1;

    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.goTo(this.position - 1, true));
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.goTo(this.position + 1, true));

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target.querySelector('video');
          if (!video) return;

          if (entry.intersectionRatio >= 0.9) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      },
      { root: this.track, threshold: [0, 0.9] }
    );
    this.items.forEach((item) => this.observer.observe(item));

    if ('onscrollend' in window) {
      this.track.addEventListener('scrollend', () => this.settle());
    } else {
      this.scrollTimeout = null;
      this.track.addEventListener('scroll', () => {
        clearTimeout(this.scrollTimeout);
        this.scrollTimeout = setTimeout(() => this.settle(), 120);
      });
    }

    this.goTo(this.realStart + Math.min(2, count - 1), false);
  }

  goTo(position, smooth) {
    this.position = position;
    const item = this.items[this.position];
    // Scroll only the carousel track itself, never the page: scrollIntoView's
    // `block` option walks up every scrollable ancestor (including the
    // document), so centering a below-the-fold slide on connect would jump
    // the whole page down to it. getBoundingClientRect avoids relying on
    // offsetParent, which isn't guaranteed to be this.track.
    const trackRect = this.track.getBoundingClientRect();
    const itemRect = item.getBoundingClientRect();
    const itemLeftInTrack = itemRect.left - trackRect.left + this.track.scrollLeft;
    const targetScrollLeft = itemLeftInTrack - (trackRect.width - itemRect.width) / 2;
    this.track.scrollTo({
      left: targetScrollLeft,
      behavior: smooth === false ? 'auto' : 'smooth',
    });
  }

  settle() {
    if (this.position < this.realStart) {
      this.goTo(this.position + this.count, false);
    } else if (this.position > this.realEnd) {
      this.goTo(this.position - this.count, false);
    }
  }
});
